import React from 'react';
import guide from './guide-how-website-visitor-works.png';
import user from './user.png';
import styles from './HowXRayWorksVersionA.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { WebsiteScreenshot } from '../WebsiteScreenshot/WebsiteScreenshot';
import { LLRActionButtons } from '../LLRActionButtons/LLRActionButtons';

export const HowXRayWorksVersionA = ({
  websiteURL,
  currentTraffic,
  additionalLeads,
  onClick,
  src,
  canResolveDomain,
  isWhiteLabel,
}: {
  websiteURL: string;
  currentTraffic: number;
  additionalLeads: number;
  onClick: () => void;
  src: string;
  canResolveDomain?: boolean;
  isWhiteLabel?: boolean;
}) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <div className={styles.titleBold}>
        How does {isWhiteLabel ? '' : 'Customers.ai X-Ray pixel'} website
        visitor identification work?
      </div>
      <div>
        {isWhiteLabel ? 'Our tool' : 'Customers.ai X-Ray Pixel'} automatically
        captures emails from{' '}
        <span className={styles.website}>{websiteURL}</span> website traffic.
      </div>
    </div>
    <div className={styles.guide}>
      <div
        className={classNames(
          styles.block,
          styles.gap24,
          styles.guideDescription,
        )}
      >
        <div
          className={classNames(styles.block, styles.gap8, styles.alignStart)}
        >
          <div className={styles.mediumTitle}>
            Capture leads{' '}
            <span className={styles.highlighted}>
              without popups or widgets.
            </span>{' '}
          </div>
          <div className={styles.text}>
            Our partner opt-in network tracks and identifies the emails and
            contact information of 250 Million users in North America.
            <br />
            <br />
            <span style={{ fontWeight: 500 }}>
              By matching devices, actions, drivers, software and 150+ signals
              to users we are able to identify 15-20% of your anonymous website
              traffic with a 99.5% confidence and provide you with an email &
              contact information.
            </span>{' '}
          </div>
        </div>
        {!isWhiteLabel && (
          <LLRActionButtons onClick={onClick} websiteURL={websiteURL} />
        )}
      </div>
      <div className={styles.guideWrapper}>
        <div className={styles.screenshotStep}>
          <div className={styles.step}>
            Step 1.
            <div className={styles.timestamp}>
              Anonymous user landed on your website at{' '}
              {moment().format('h:mm a')} {moment().format('MMMM Do')}
            </div>
          </div>
          <WebsiteScreenshot
            canResolve={canResolveDomain}
            websiteURL={websiteURL}
            src={src}
            css={{
              container: styles.screenshotContainer,
              image: styles.screenshotImage,
            }}
          />
          <img src={user} className={styles.userIcon} />
        </div>

        <img src={guide} className={styles.image} />
      </div>
    </div>
  </div>
);
